import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
`;

export const Content = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 0 20px 0;
  background-color: ${(props) => props.theme.colors.footerBackgroundColor};

  @media screen and (max-width: 480px) {
    margin-top: 20px;

    p {
      width: 100%;
      text-align: center;
      font-size: 14px;
    }
  }

  p {
    font-weight: 500;
    margin-bottom: 20px;
  }
  em {
    font-weight: 700;
  }
`;
